// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"header-bread-crumb_breadcrumb__1v4Am","title":"header-bread-crumb_title__2YG83","backPage":"header-bread-crumb_backPage__1-UPe"};